import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PedidoLiberacaoView } from "../model/view/PedidoLiberacaoView";
import { Aviso } from '../model/Aviso';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
    providedIn: 'root'
  })
export class PedidoLiberacaoService {

    private BASE_URL = './rest/pedido-liberacao';

    constructor(private http: HttpClient){}

    obterPedidosDeLiberacao(idPAC:  number): Observable<PedidoLiberacaoView[]>{
        return this.http.get<PedidoLiberacaoView[]>(this.BASE_URL+"/"+idPAC)
    }

    buscarAvisosAnalisePL(idPac: number): Observable<Aviso[]>{
        return this.http.get<Aviso[]>(`${this.BASE_URL}/avisos-analise-pl/${idPac}`, 
        {
            ...blockUi(),
            observe: 'body'
        }
    ).pipe();
    }
}